/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const orgTypeNameSchema = z
  .enum(['None', 'Org', 'Edu', 'Intern', 'Edy365'])
  .describe('Member names of OrgType.')
